import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils, translate } from 'versafleet-core';

class MeasurementEditItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      useDimensions: (
        !Utils.Helper.isNullOrUndefined(props.data.volume_height)
          || !Utils.Helper.isNullOrUndefined(props.data.volume_length)
          || !Utils.Helper.isNullOrUndefined(props.data.volume_width)),
    };
  }

  _onFormChange(fieldName, value, isDelete) {
    const { data } = this.props;
    if (!Utils.Helper.isNullOrUndefined(fieldName)) {
      data[fieldName] = value;
    }

    const obj = data;
    if (this.state.useDimensions) {
      obj.volume_length = data.volume_length;
      obj.volume_width = data.volume_width;
      obj.volume_height = data.volume_height;
      obj.volume = null;
    } else {
      obj.volume_length = null;
      obj.volume_width = null;
      obj.volume_height = null;
      obj.volume = data.volume;
    }

    this.props.onFormChange(
      {
        ...data,
        ...obj,
      },
      this.props.index,
      isDelete,
    );
  }

  _switchVolumeInput() {
    if (this.state.useDimensions === true) {
      // Change to volume input, clear out dimensions
      this.setState({
        useDimensions: false,
      });
    } else {
      this.setState({
        useDimensions: true,
      });
    }
    this._onFormChange(null);
  }

  render() {
    const {
      id, account, strings, error, data, displayedIndex, versadriveSetting,
    } = this.props;

    if (data._destroy) {
      return false;
    }

    const hasDimensions = (
      !Utils.Helper.isNullOrUndefined(data.volume_length)
        && !Utils.Helper.isNullOrUndefined(data.volume_height)
        && !Utils.Helper.isNullOrUndefined(data.volume_width)
    );
    const hasVolume = !Utils.Helper.isNullOrUndefined(data.volume);

    // Calculate the volume
    const volume = (
      !Utils.Helper.isNullOrUndefined(data.volume_length)
        && !Utils.Helper.isNullOrUndefined(data.volume_height)
        && !Utils.Helper.isNullOrUndefined(data.volume_width)
        ? data.volume_length * data.volume_width * data.volume_height
        : data.volume
    );

    const measurementUnits = Utils.Helper.getMeasurementUnits();
    const volumeUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].volumeUnit : 'in³';
    const dimensionUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].dimensionUnit : 'in';
    const weightUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].weightUnit : 'lb';
    const shippingFactorUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].shippingFactorUnit : 'in³/lb';

    const editCustomId = versadriveSetting.delivery_job_scan_enabled
      || versadriveSetting.delivery_task_scan_enabled
      || versadriveSetting.pickup_job_scan_enabled
      || versadriveSetting.pickup_task_scan_enabled;

    return (
      <div className="vf-measurement-edit-item">
        <div className="vf-measurement-edit-item__index">
          {`${displayedIndex + 1}.`}
        </div>

        <div className="vf-measurement-edit-item__content">

          <div className="vf-measurement-edit-item__quantity">
            <Components.Input.Textbox
              className="vf-measurement-edit-item__textbox
                vf-measurement-edit-item__textbox--small"
              error={error.quantity}
              id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__quantity-input`}
              key="measurement-quantity"
              onChange={value => this._onFormChange('quantity', value)}
              placeholder={strings.measurements.quantityHint}
              value={data.quantity}
              width="narrow"
            />
            <span className="vf-measurement-edit-item__text
              vf-measurement-edit-item__multiplier"
            >
              x
            </span>
            <Components.Input.Textbox
              className="vf-measurement-edit-item__textbox"
              error={error.quantity_unit}
              id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__quantity-unit-input`}
              key="measurement-quantity-unit"
              onChange={value => this._onFormChange('quantity_unit', value)}
              placeholder={strings.measurements.unitHint}
              value={data.quantity_unit}
              width={editCustomId ? 'narrow' : 'wide'}
            />
            {editCustomId && (
              <Components.Input.Textbox
                error={error.custom_item_id}
                id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__custom-item-id-input`}
                onChange={value => this._onFormChange('custom_item_id', value)}
                placeholder={strings.measurements.customItemIdHint}
                value={data.custom_item_id}
                width="narrow"
              />
            )}
          </div>

          <Components.Input.Textbox
            error={error.description}
            id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__description-input`}
            key="measurement-description"
            onChange={value => this._onFormChange('description', value)}
            placeholder={strings.measurements.descriptionHint}
            value={data.description}
          />

          <div className="vf-measurement-edit-item__volume">

            <div className="vf-measurement-edit-item__volume__block">
              <div className="vf-measurement-edit-item__volume__block__header">Actual weight</div>
              <div className="vf-measurement-edit-item__volume__block__text">
                <Components.Input.Textbox
                  className="vf-measurement-edit-item__textbox"
                  error={error.weight}
                  id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__actual-weight-input`}
                  key="measurement-weight"
                  onChange={value => this._onFormChange('weight', value)}
                  placeholder="0"
                  value={data.weight}
                />
                <span className="vf-measurement-edit-item__text">{weightUnit}</span>
              </div>
            </div>

            <div className="vf-measurement-edit-item__volume__block">
              <div className="vf-measurement-edit-item__volume__block__header">
                {strings.measurements.volume}
              </div>
              <div className="vf-measurement-edit-item__volume__block__text">
                {this.state.useDimensions ? [
                  <Components.Input.Textbox
                    className="vf-measurement-edit-item__textbox"
                    error={error.volume_length}
                    id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__volume-length-input`}
                    key="measurement-volume-length"
                    onChange={value => this._onFormChange('volume_length', value)}
                    placeholder={strings.measurements.length}
                    value={data.volume_length}
                  />,
                  <span className="vf-measurement-edit-item__text
                    vf-measurement-edit-item__multiplier"
                  >
                    x
                  </span>,
                  <Components.Input.Textbox
                    className="vf-measurement-edit-item__textbox"
                    error={error.volume_width}
                    id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__volume-width-input`}
                    key="measurement-volume-width"
                    onChange={value => this._onFormChange('volume_width', value)}
                    placeholder={strings.measurements.width}
                    value={data.volume_width}
                  />,
                  <span className="vf-measurement-edit-item__text
                    vf-measurement-edit-item__multiplier"
                  >
                    x
                  </span>,
                  <Components.Input.Textbox
                    className="vf-measurement-edit-item__textbox"
                    error={error.volume_height}
                    id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__volume-height-input`}
                    key="measurement-volume-height"
                    onChange={value => this._onFormChange('volume_height', value)}
                    placeholder={strings.measurements.height}
                    value={data.volume_height}
                  />,
                  <span className="vf-measurement-edit-item__text">{dimensionUnit}</span>,
                ] : [
                  <Components.Input.Textbox
                    className="vf-measurement-edit-item__textbox"
                    error={error.volume}
                    id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__volume-input`}
                    key="measurement-volume"
                    onChange={value => this._onFormChange('volume', value)}
                    placeholder={strings.measurements.volume}
                    value={data.volume}
                  />,
                  <span className="vf-measurement-edit-item__text">{volumeUnit}</span>,
                ]}
              </div>
              <div
                className="vf-measurement-edit-item__volume__block__subtext
                  vf-measurement-edit-item__volume__block__input-toggler"
                id={Utils.Helper.isNullOrUndefined(id) ? undefined
                  : `${id}__use-${this.state.useDimensions ? 'volume' : 'dimension'}`}
                onClick={this._switchVolumeInput.bind(this)}
              >
                {this.state.useDimensions ? strings.measurements.useVolume
                  : strings.measurements.useDimension}
              </div>
            </div>

            <div className="vf-measurement-edit-item__volume__block">
              <div className="vf-measurement-edit-item__volume__block__header">Volumetric Weight</div>
              <div className="vf-measurement-edit-item__volume__block__text">
                {(!hasVolume && !hasDimensions)
                  || Utils.Helper.isNullOrUndefined(account.shipping_factor)
                  ? '-' : `${Utils.Helper.calculateVolumetricWeight(
                    volume,
                    account.shipping_factor,
                    account.unit_system,
                  )}${weightUnit}`}
              </div>
              {(!hasVolume && !hasDimensions)
                || Utils.Helper.isNullOrUndefined(account.shipping_factor) ? false
                : (
                  <div className="vf-measurement-edit-item__volume__block__subtext">
                    {`${strings.constants.by} ${
                      account.shipping_factor} ${shippingFactorUnit}`}
                  </div>
                )}
            </div>

          </div>
        </div>

        <Components.Delete
          delayTime={0}
          delete={() => this._onFormChange(null, null, true)}
          id="vf-measurement-edit-item__delete"
          ids={[1]} // actual value doesn't matter, it's for counting the number of deleted items
          modelName="item"
        >
          <div>
            <i className="vf-measurement-edit-item__delete versa-delete" />
          </div>
        </Components.Delete>
      </div>
    );
  }
}

MeasurementEditItem.displayName = 'Measurement Edit Item';

MeasurementEditItem.propTypes = {
  account: PropTypes.shape({
    shipping_factor: PropTypes.number,
    unit_system: PropTypes.string,
  }).isRequired,
  data: PropTypes.shape(),
  displayedIndex: PropTypes.number.isRequired,
  error: PropTypes.shape({
    custom_item_id: PropTypes.arrayOf(PropTypes.string),
    quantity: PropTypes.arrayOf(PropTypes.string),
    quantity_unit: PropTypes.arrayOf(PropTypes.string),
    description: PropTypes.arrayOf(PropTypes.string),
    weight: PropTypes.arrayOf(PropTypes.string),
    volume_length: PropTypes.arrayOf(PropTypes.string),
    volume_width: PropTypes.arrayOf(PropTypes.string),
    volume_height: PropTypes.arrayOf(PropTypes.string),
    volume: PropTypes.arrayOf(PropTypes.string),
  }),
  id: PropTypes.string,
  index: PropTypes.number.isRequired,
  onFormChange: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    constants: PropTypes.shape({
      by: PropTypes.string,
    }),
    measurements: PropTypes.shape({
      customItemIdHint: PropTypes.string,
      quantityHint: PropTypes.string,
      unitHint: PropTypes.string,
      descriptionHint: PropTypes.string,
      volume: PropTypes.string,
      length: PropTypes.string,
      width: PropTypes.string,
      height: PropTypes.string,
      useVolume: PropTypes.string,
      useDimension: PropTypes.string,
    }),
  }).isRequired,
  versadriveSetting: PropTypes.shape({
    delivery_job_scan_enabled: PropTypes.bool,
    delivery_task_scan_enabled: PropTypes.bool,
    pickup_job_scan_enabled: PropTypes.bool,
    pickup_task_scan_enabled: PropTypes.bool,
  }).isRequired,
};

MeasurementEditItem.defaultProps = {
  data: {},
  error: {},
  id: 'measurement-edit-item',
};

function mapStateToProps(state) {
  const { account, versadriveSetting } = state;
  return {
    account: account.account,
    versadriveSetting: versadriveSetting.versadriveSetting,
  };
}

export default connect(mapStateToProps)(translate('Task')(MeasurementEditItem));
